import { SpecificEventMap } from 'events/lib'
import { useEvent } from 'hooks/useEvent'

export const useDrawerOpenEvent = <T extends keyof SpecificEventMap>({
  ns,
  elementId,
  onOpen
}: {
  ns?: T,
  elementId?: keyof SpecificEventMap[T],
  onOpen?: () => void
}) => {
  const { fireEvent: openEvent } = useEvent(ns)
  const handleOpen = () => {
    if (elementId) {
      openEvent(elementId)
    }
    if (onOpen) {
      onOpen()
    }
  }

  return handleOpen
}

export default useDrawerOpenEvent
